import { faInfoCircle, faMinusCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { cartPostAction, getCartItems } from "../../actions/cartAction";
import { getPatientNotification } from "../../actions/dashboardAction";
import { getUserDetail } from "../../utils/helper";
import ConfirmDialog from "../ConfirmDialog";
const CartProductItem = ({ item }) => {
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const dispatch = useDispatch();
  const role = useSelector((state) => state.role.role);
  const removeItem = () => {
    var params = {
      params: {
        action: "removeCartItem",
        itemId: item.productId,
        isPrescription: 0,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      cartPostAction(params, () => {
        dispatch(getCartItems(role.val));
        dispatch(getPatientNotification(role.val));
      })
    );
  };

  const updateQuantity = (quantity) => {
    var params = {
      params: {
        action: "updateQuantity",
        itemId: item.productId,
        isPrescription: 0,
        quantity: quantity,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      cartPostAction(params, () => {
        dispatch(getCartItems(role.val));
        dispatch(getPatientNotification(role.val));
      })
    );
  };

  const getOptions = () => {
    let options = [];
    for (let index = 1; index <= parseInt(item.totalQuantity); index++) {
      if (index > 5) break;
      options.push(<option value={index}>{index}</option>);
    }
    return options;
  };

  return (
    <div>
      {showConfirmDialog && (
        <ConfirmDialog
          title="Are you sure want to remove this product?"
          acceptAction={removeItem}
          acceptText="yes"
          rejectText="no"
          closePopup={() => setShowConfirmDialog(false)}
        />
      )}
      <div className="cart_container" id="cart_content">
        <div className="cart-icon" style={{ padding: "5px" }}>
          <div
            className="cart-cancel"
            onClick={() => setShowConfirmDialog(true)}
          >
            <FontAwesomeIcon icon={faMinusCircle} />
          </div>
        </div>
        <div className="cart-item">
          <p style={{ marginBottom: "0px" }}>{item.Name}</p>
        </div>
        <div className="card-image cart">
          <img src={item.imageUrl} alt="prod=item" />
        </div>

        <div className="cart-weight">
          <p style={{ display: "inline-block" }}>
            Weight:&nbsp;
            <span>
              {parseFloat(item.weight).toLocaleString("en-US", {
                maximumFractionDigits: 1,
                minimumFractionDigits: 1,
              })}{" "}
              grams
            </span>
          </p>
        </div>

        {parseInt(item.totalQuantity) > 0 ? (
          <>
            {item.quantity <= parseInt(item.totalQuantity) && (
              <div className="cart-weight">
                <p style={{ display: "inline-block" }}>
                  Quantity:&nbsp;
                  <span>
                    <select
                      value={parseInt(item.quantity)}
                      onChange={(e) => {
                        updateQuantity(e.target.value);
                      }}
                    >
                      {getOptions()}
                    </select>{" "}
                    unit
                  </span>
                </p>
              </div>
            )}

            {item.quantity <= parseInt(item.totalQuantity) ? (
              <div className="cart-total">
                <p
                  style={{
                    fontWeight: "bold",
                    fontSize: "16px",
                    marginBottom: "0px",
                  }}
                >
                  Total
                </p>
                <p>
                  {parseFloat(item.price / 100).toLocaleString("en-US", {
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                    style: "currency",
                    currency: "USD",
                  })}
                </p>
              </div>
            ) : (
              <div className="cart-weight">
                <div className="cart-weight">
                  <p style={{ display: "inline-block" }}>
                    Quantity:&nbsp;
                    <span>
                      <select
                        value={parseInt(item.quantity)}
                        onChange={(e) => {
                          updateQuantity(e.target.value);
                        }}
                      >
                        <option value="">0</option>
                        {getOptions()}
                      </select>{" "}
                      unit
                    </span>
                  </p>
                </div>
                <label style={{ color: "red" }}>
                  <FontAwesomeIcon size="sm" icon={faInfoCircle} /> The quantity
                  you have selected before is more than that in our inventory,
                  please select again.
                </label>
              </div>
            )}
          </>
        ) : (
          <div className="cart-weight" style={{ color: "red" }}>
            <FontAwesomeIcon size="sm" icon={faInfoCircle} /> This product is
            temporarily out of stock, we will replenish it as soon as possible.
          </div>
        )}
      </div>
    </div>
  );
};
export default CartProductItem;
